import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { MomentModule } from 'ngx-moment';
import { ItemViewModel } from 'src/app/models/item.model';

@Component({
  selector: 'app-list-item-header',
  templateUrl: './list-item-header.component.html',
  styleUrls: ['./list-item-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MomentModule, IonIcon]
})
export class ListItemHeaderComponent implements OnInit {
  @Input() item: ItemViewModel;
  public legend: string;
  public iconSrc: string;
  public legendClass: string;

  ngOnInit(): void {
    switch (this.item.itemType) {
      case 0:
        this.legend = 'Channel post';
        this.legendClass = 'channel-post';
        this.iconSrc = '/assets/icon/channel-icon.svg';
        break;

      case 1:
        this.legend = 'Direct message';
        this.legendClass = 'direct-message';
        this.iconSrc = '/assets/icon/new-dm-icon.svg';
        break;

      case 2:
        this.legend = 'Attendance Alert';
        this.legendClass = 'attendance-alert';
        this.iconSrc = '/assets/icon/attendance-alert-icon.svg';
        break;

      case 3:
        this.legend = 'Payment message';
        this.legendClass = 'payment-message';
        this.iconSrc = '/assets/icon/payment-request.svg';
        break;

      case 4:
        this.legend = 'Slip message';
        this.legendClass = 'slip-message';
        this.iconSrc = '/assets/icon/slip-icon.svg';
        break;

      default:
        this.legend = 'Update needed';
        this.legendClass = 'unknown-item';
        this.iconSrc = '/assets/icon/unknown-item-icon.svg';
        break;
    }
  }

  isUnread(): boolean {
    return !this.item.read;
  }

  get formats(): any {
    return {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[last] dddd [at] LT',
      sameElse: 'DD/MM/YYYY'
    };
  }
}
